import { render, staticRenderFns } from "./addOwner.vue?vue&type=template&id=31e2090a&"
import script from "./addOwner.vue?vue&type=script&lang=js&"
export * from "./addOwner.vue?vue&type=script&lang=js&"
import style0 from "./addOwner.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports